import React from 'react'
import '../styles/style.css'
import female from '../images/female.svg'
import male from '../images/male.svg'
import back from '../images/back.svg'
import replay from '../images/replay.svg'
class BmiCalculator extends React.Component {

    //standard means - feet, inches and pounds as input
    //   metric means - meter,cm  and kgs as ip
    constructor(props) {
        super(props);
        this.state = {
            unit: 'metric',
            gender: 'Male',
            height1: '',
            height2: '',
            weight: '',
            regexp: /^[0-9\b]+$/,
            resultScreen: false,
            BmiScore: 0,
            BmiStatus: '',
            BmiMessage: '',
            BmiColor: '',
            errorField: false

        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.selectedCategory = this.selectedCategory.bind(this);
        this.selectedGender = this.selectedGender.bind(this);
        this.calculateBmi = this.calculateBmi.bind(this);
        this.baseState = this.state
    }



    handleSubmit(event) {
        console.log("STATE---", this.state);

        this.calculateBmi();
        //event.preventDefault();
    }
    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        console.log("Name", name, "Value", value);
        if (value === '' || this.state.regexp.test(value)) {
            this.setState({
                ...this.state,
                [name]: parseInt(value) || 0
            });
        }

    }
    calculateBmi() {
        let height1 = this.state.height1;
        let height2 = this.state.height2;
        let weight = this.state.weight;

        let BmiScore = 0;
        let BmiStatus = '';
        let BmiColor = '';
        let BmiMessage = '';




        if (this.state.unit === 'standard') {
            let height = height1 * 12 + height2;
            //BmiScore = weight/((height - 60)/5 + 5);
            BmiScore = 703 * (weight / (height * height));

        }
        else {
            let height = height1 + height2 / 100;
            BmiScore = weight / (height * height);
            // BmiScore=weight/(3.5*(height - 1.5)+2.2);
        }
        if (BmiScore < 18.5) {
            BmiColor = 'red';
            BmiMessage='Your ideal weight should be more than your current weight. Time to work on it! Keep following the expert videos for best health advice.'
        }
        else if (BmiScore >= 18.5 && BmiScore < 25) {
            BmiColor = 'green';
            BmiMessage = 'Wow! You are at an ideal weight. Keep maintaining it! Do follow the expert videos for best health advice.'
        }
        else if (BmiScore >= 25 && BmiScore < 30) {
            BmiColor = 'red';
            BmiMessage='Your ideal weight should be lesser than your current weight. Time to work on it! Keep following the expert videos for best health advice.'
        }
        else {
            BmiColor = 'blue';
            BmiMessage='Your current weight is alarmingly higher than your ideal weight! Do start a focussed plan on weight managemnt right away. Keep following the expert videos for best health advice.'
        }
        this.setState({
            ...this.state,
            resultScreen: true,
            BmiScore: Math.round(BmiScore),
            BmiColor,
            BmiMessage

        });
    }
    goBack = () => {
        this.props.history.goBack()
    }

    selectedCategory(category) {
        console.log("category", category);
        this.setState({
            ...this.state,
            unit: category
        });
    }
    selectedGender(input) {
        console.log("Gender", input);
        this.setState({
            ...this.state,
            gender: input
        });
    }



    render() {
        let category = this.state.unit;
        let maleClass = this.state.gender === "Male" ? 'gender-select male' : 'male';
        let femaleClass = this.state.gender === "Female" ? 'gender-select female' : 'female';
        let isStandard = (category === "standard");
        return (
            <div className="container-bmi">
                <div className="header-home pp-head" >
                    {!this.state.resultScreen ?
                        <img src={back} onClick={this.goBack} className="imgggg"></img> : <img src={back} onClick={() => this.setState(this.baseState)}></img>}
                    <p style={{ textAlign: "left" }} className="bmiii">BMI Calculator</p>
                </div>

                {!this.state.resultScreen ?
                    <div className="mm-13">
                        <div className="content-bmi">
                            <div className="bmi-option">
                                <div onClick={() => { this.selectedCategory("standard") }} className={
                                    category === "standard" ? 'selected' : ''
                                }>Standard</div>
                                <div onClick={() => { this.selectedCategory("metric") }} className={
                                    category === "metric" ? 'selected' : ''
                                }>Metric</div>
                            </div>
                            <div className="calculator">
                                <div className={maleClass} onClick={() => { this.selectedGender("Male") }}>
                                    <img src={male}></img>
                                    <p>Male</p>
                                </div>
                                <div className={femaleClass} onClick={() => { this.selectedGender("Female") }}>
                                    <img src={female}></img>
                                    <p>Female</p>
                                </div>
                            </div>

                            <div className="dimensions">
                                <div>Height</div>
                                <div className="ft">
                                    <span><input type="tel" maxLength='3' name="height1" value={this.state.height1} onChange={this.handleChange} required></input></span>
                                    <span>{isStandard ? "Ft" : "Mt"}</span>
                                </div>
                                <div className="inch">
                                    <span><input type="tel" maxLength='3' name="height2" value={this.state.height2} onChange={this.handleChange} required></input></span>
                                    <span>{isStandard ? "in" : "cm"}</span>
                                </div>
                            </div>
                            <div className="dimensions m-tp-20">
                                <div>Weight</div>
                                <div className="ft">
                                    <span><input type="tel" maxlength="3" name="weight" value={this.state.weight} onChange={this.handleChange} required></input></span>
                                    <span>{isStandard ? "lbs" : "kg"}</span>
                                </div>
                                <div className="inch none">
                                    <span><input type="tel" maxLength='3' name="weight" value={this.state.weight} onChange={this.handleChange} required></input></span>
                                    <span>Ft</span>
                                </div>
                            </div>
                        </div>
                        <button disabled={((this.state.height1 === "" || this.state.height2 === "") || (!this.state.height1 && !this.state.height2) || !this.state.weight)}
                            type="submit" className={((this.state.height1 === "" || this.state.height2 === "") || (!this.state.height1 && !this.state.height2) || !this.state.weight) ? "disabledBtn c-bmi " : "c-bmi"} onClick={this.handleSubmit}>Calculate your BMI</button>
                    </div>
                    :
                    <div className="cover">
                        <div className="content-bmi cal-pad">
                            <div className='replay' onClick={() => this.setState(this.baseState)}>
                                <img src={replay}></img>
                            </div>
                            <div className="output">
                                <p>Your Result</p>
                                <p className={this.state.BmiColor}>{this.state.BmiScore}</p>
                                <p>{this.state.BmiMessage}</p>
                            </div>
                            <div className="result">
                                <p className="category">BMI Categories :</p>
                                <p className="category-item"><span>Underweight</span> <span>=</span><span>{`>`}18.5</span></p>
                                <p className="category-item"><span>Normal weight</span> <span>=</span> <span className="green">18.5-24.9</span></p>
                                <p className="category-item"><span>Overweight</span> <span>=</span> <span>25-29.9</span></p>
                                <p className="category-item"><span className="blue">Obesity</span> <span className="blue">=</span> <span className="blue">BMI of 30 or greater</span></p>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default BmiCalculator;